import brakes from '~/assets/icons/brakes.svg';
import flash from '~/assets/icons/flash_2.svg';
import transmission from '~/assets/icons/transmission.svg';
import wheel from '~/assets/icons/wheel_2.svg';
import { Text } from '~/components/ui/Text';
import { TechTuningItemProperty } from '~/shared';
import {
	StyledHintContainer,
	StyledHintInfoContainer,
	StyledHintInfoItem,
} from './ShopTuningShopHint.styled';

const ShopTuningShopHint = ({
	name,
	properties,
	...props
}: {
	name: string;
	properties?: Record<TechTuningItemProperty, number | null>;
} & React.HTMLAttributes<HTMLDivElement>) => {
	const formatValue = (value: number) => {
		if (value === 0) {
			return '0';
		}
		if (value > 0) {
			return `+${value}`;
		}
		return `${value}`;
	};

	return (
		<StyledHintContainer {...props}>
			<Text>{name}</Text>
			<StyledHintInfoContainer>
				{properties?.boost !== null && properties?.boost !== undefined && (
					<StyledHintInfoItem>
						<div className="icon" style={{ backgroundColor: '#8230BB' }}>
							<img src={transmission} />
						</div>
						<Text>
							{formatValue(properties.boost)} <span>кмч</span>
						</Text>
					</StyledHintInfoItem>
				)}
				{properties?.acceleration !== null &&
					properties?.acceleration !== undefined && (
						<StyledHintInfoItem>
							<div className="icon" style={{ backgroundColor: '#FFA600' }}>
								<img src={flash} style={{ filter: 'invert(1)' }} />
							</div>
							<Text>
								{formatValue(properties.acceleration)} <span>ускорение</span>
							</Text>
						</StyledHintInfoItem>
					)}
				{properties?.traction !== null &&
					properties?.traction !== undefined && (
						<StyledHintInfoItem>
							<div className="icon" style={{ backgroundColor: '#13C075' }}>
								<img src={wheel} />
							</div>
							<Text>
								{formatValue(properties.traction)} <span>cцепление</span>
							</Text>
						</StyledHintInfoItem>
					)}
				{properties?.braking !== null && properties?.braking !== undefined && (
					<StyledHintInfoItem>
						<div className="icon" style={{ backgroundColor: '#DD1515' }}>
							<img src={brakes} />
						</div>
						<Text>
							{formatValue(properties.braking)} <span>торможение</span>
						</Text>
					</StyledHintInfoItem>
				)}
			</StyledHintInfoContainer>
		</StyledHintContainer>
	);
};

export { ShopTuningShopHint };
